import USER_TYPES from '@/constants/authorization/user-types'

export default [
  {
    title: 'navigation.crm',
    userTypes: [USER_TYPES.BRANCH_ADMIN],
    svgIcon: 'icon-crm',
    children: [
      {
        title: 'client.customers-list',
        svgIcon: 'icon-customers-list',
        route: 'admin:customers',
        userTypes: [USER_TYPES.BRANCH_ADMIN],
      },
      {
        title: 'client.customers-statistics',
        svgIcon: 'icon-customers-statistics',
        route: 'admin:customers:statistics',
        userTypes: [USER_TYPES.BRANCH_ADMIN],
      },
      {
        title: 'client.items-insight',
        svgIcon: 'icon-items-insight',
        route: 'admin:customers:items-insight',
        userTypes: [USER_TYPES.BRANCH_ADMIN],
      },
      {
        title: 'self-compare.self-compare',
        svgIcon: 'self-compare',
        route: 'admin:reports:self-compare',
        userTypes: [USER_TYPES.BRANCH_ADMIN],
      },
    ],
  },

]
